import { Design, DesignSearchResponse, DesignsResponse } from '@/types';

export const mapDesignSearchResult = (r: DesignSearchResponse): DesignsResponse => ({
  count: r.total,
  designs: r.results.map(
    (d): Design => ({
      backgroundColor: d.backgroundColor,
      colors: d.colors.map((c) => ({
        layer: c.layer,
        origin: `#${c.color}`,
      })),
      created: d.created,
      customerUpload: false,
      free: d.isFree,
      id: `${d.designId}`,
      ideaId: d.compositionId,
      name: d.name,
      printTypes: d.printTypeIds.map((p) => ({ id: `${p}` })),
      restrictions: {
        allowRotate: d.allowRotate,
        allowScale: d.allowScale,
        fixedColors: d.fixedColors,
        minimumScale: d.minimumScale,
      },
      safeSearch: d.isAdultContent ? 'OFF' : 'STRICT',
      size: d.size,
      user: { id: `${d.designerId}` },
    })
  ),
});
